module.exports = __webpack_public_path__ + "img/activity_active.aba1b38e.png";